import { useAuth0 } from "@auth0/auth0-react";
import EventDrawerSkelton from "components/Skelton/PastoralSkelton/EventDrawerSkelton";
import PastoralService from "Lib/API/PastoralApi";
import React, { useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import RightDrawer from "../../../components/drawer";
import EditMemberDrawer from "./editMember.js";
import MemberEventDrawerContent from "./MemberEventDrawerContent";
import MemberEventDrawerHead from "./MemberEventDrawerHead";
import "./styles.scss";

const MemberEventDrawer = ({ openNewTaskDrawer, eventId,setCallFeedsAgain,setCallEventsTypeAgain, openConfirmDelete }) => {
	const { getAccessTokenSilently } = useAuth0();

	// const [openEditMember, setOpenEditMember] = useState(false);
	const [loading, setLoading] = useState(true);
	const [eventData, setEventData] = useState({});
	const [eventStatusLoading, setEventStatusLoading] = useState(false);
	// const handleEditMember = () => {
	// 	setOpenEditMember(true);
	// };

	const getEventHandler = async () => {
		const token = await getAccessTokenSilently();
		setLoading(true);
		PastoralService.getEventById({ token, eventId: eventId })
			.then((res) => {
				if (res) {
					setEventData(res?.data);
				}
			})
			.catch((err) => {
				toastr.error("Error", err?.data?.message || "Something went wrong");
			})
			.finally(() => {
				setLoading(false);
			});
	};

	useEffect(() => {
		getEventHandler();
	}, []);


	const updateEventStatusHandler = async () => {
		if(eventStatusLoading) return;
		setEventStatusLoading(true);
		const token = await getAccessTokenSilently();
		const bodyData = {
			archived: eventData?.archived === 0,
		};
		PastoralService.updateEvent({ data: bodyData, token, eventId, })
			.then((res) => {
				if (res) {
					toastr.success("Success", "Event status updated successfully");
					setEventData((prevState) => {
						return {
							...prevState,
							archived: bodyData?.archived ? 1 : 0,
						};
					});
					setCallEventsTypeAgain((prevState) => !prevState);
				}
			})
			.catch((err) => {
				toastr.error("Error", err?.data?.message || "Something went wrong");
			})
			.finally(() => {
				setEventStatusLoading(false);
			});
	}

	const deleteEventHandler = () => {
		openConfirmDelete()
	}


	return (
		<div className="profile-drawer account-drawer main-drawer">
			{loading ? (
				<EventDrawerSkelton />
			) : (
				<>
					<MemberEventDrawerHead
						name={eventData?.fullName}
						contactId={eventData?.involvedContactId}
						addedDate={eventData?.added}
						email={eventData?.email}
						phone={eventData?.mobile}
						content={eventData?.content}
						updateEventStatus={updateEventStatusHandler}
						status={eventData?.archived}
						deleteEvent={deleteEventHandler}
					/>

					<MemberEventDrawerContent
						contactId={eventData?.involvedContactId}
						eventId={eventId}
						eventType={eventData?.eventTypeName}
						eventDate={eventData?.date}
						status={eventData?.archived}
						description={eventData?.memo || ""}
						openNewTaskDrawer={openNewTaskDrawer}
						setCallFeedsAgain={setCallFeedsAgain}
					/>
				</>
			)}
			{/* <RightDrawer open={openEditMember} onClose={() => setOpenEditMember(false)}>
				<EditMemberDrawer data={data} setOpenEditMember={setOpenEditMember} />
			</RightDrawer> */}
		</div>
	);
};

export default MemberEventDrawer;
